var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2223 15.1111H1.77783C1.20006 15.1111 0.622278 14.8 0.311167 14.3111C-0.0443887 13.8222 -0.088833 13.2 0.133389 12.6222C1.02228 10.3556 3.37783 8.84447 6.00006 8.84447C8.62228 8.84447 10.9778 10.3556 11.8667 12.6222C12.0889 13.1556 12.0445 13.8222 11.6889 14.3111C11.3778 14.8 10.8001 15.1111 10.2223 15.1111ZM6.00006 8.00003C4.0445 8.00003 2.4445 6.40003 2.4445 4.44447C2.4445 2.48892 4.0445 0.888916 6.00006 0.888916C7.95561 0.888916 9.55561 2.48892 9.55561 4.44447C9.55561 6.40003 7.95561 8.00003 6.00006 8.00003Z",
    fill: "#E5E5E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/userProfileIcon.1e8ef8e7dc380caf6277e223c580268a.svg";
export { ForwardRef as ReactComponent };